import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { primaryShade } from '../primary-shade/primary-shade.js';
function themeColor(theme) {
  var getPrimaryShade = primaryShade(theme);
  return function (color, shade) {
    var primaryFallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var useSplittedShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    if (typeof color === "string" && color.includes(".")) {
      var _color$split = color.split("."),
        _color$split2 = _slicedToArray(_color$split, 2),
        splitterColor = _color$split2[0],
        _splittedShade = _color$split2[1];
      var splittedShade = parseInt(_splittedShade, 10);
      if (splitterColor in theme.colors && splittedShade >= 0 && splittedShade < 10) {
        return theme.colors[splitterColor][typeof shade === "number" && !useSplittedShade ? shade : splittedShade];
      }
    }
    var _shade = typeof shade === "number" ? shade : getPrimaryShade();
    return color in theme.colors ? theme.colors[color][_shade] : primaryFallback ? theme.colors[theme.primaryColor][_shade] : color;
  };
}
export { themeColor };